import { ImageCustom } from '@/components';
import ModalSelectVariantV2 from '@/components/ModalSelectVariant/ModalSelectVariantV2';
import { Variant } from '@/models';
import { useCart } from '@/modules/shared/hooks';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';

interface AttributeWithVariantID {
	id: number;
	key: string;
	value: string;
	variantId: number;
}

export interface CartItemV2Props {
	id: number;
	image?: string;
	name: string;
	variantsList: Variant[];
	variants: Variant;
	quantity: number;
	onRemoveItem: (id: number) => void;
	onChangeItemQuantity: (productId: number, newQuantity: number) => void;
	onChangeItemVariant: (productId: number, newVariant: number) => void;
}

const CartItemV2: React.FC<CartItemV2Props> = ({
	id,
	name,
	variantsList,
	quantity,
	image,
	variants,
	onRemoveItem,
	onChangeItemQuantity,
	onChangeItemVariant,
}) => {
	const router = useRouter();
	const [variantDialog, setVariantDialog] = React.useState(false);
	const [numb, setNumb] = React.useState<number>(quantity);
	const [variant, setVariant] = React.useState<number | null>(variants.id);

	const handleDialog = () => {
		setVariantDialog(!variantDialog);
	};

	const handleSelectVariant = (variantIds: number) => {
		setVariant(variantIds);
		onChangeItemVariant(id, variantIds);
	};

	const handleChangeQuantity = (newQuantity: number) => {
		setNumb(newQuantity);
		onChangeItemQuantity(id, newQuantity);
	};
	const genPriceValue = () => {
		if (attributeConfig.length > 0) {
			if (variant !== null) {
				const result = variantsList.find((item) => item.id === variant);

				return {
					price: result?.salePrice,
					split: result?.revenueSplit,
				};
			}

			return {
				price: variants.salePrice,
				split: variants.revenueSplit,
			};
		}

		return {
			price: variants?.salePrice ?? null,
			split: variants?.revenueSplit ?? null,
		};
	};

	const attributeList =
		variantsList?.reduce<Array<AttributeWithVariantID>>((current, next) => {
			let result = [];

			for (let i = 0; i < next.attributes.length; i++) {
				const element = next.attributes[i];
				result.push({
					...element,
					variantId: next.id,
				});
			}

			return [...current, ...result];
		}, []) ?? [];

	const attributeConfig = attributeList.reduce<{ key: string; value: any[] }[]>((current, next) => {
		const keyList = current.map((item) => item.key);

		if (keyList.includes(next.key)) {
			return current.map((item) => {
				if (item.key === next.key) {
					return {
						...item,
						value: [
							...item.value,
							{
								id: next.id,
								value: next.value,
								variantId: next.variantId,
							},
						],
					};
				}

				return {
					...item,
				};
			});
		}

		return [
			...current,
			{
				key: next.key,
				value: [
					{
						id: next.id,
						value: next.value,
						variantId: next.variantId,
					},
				],
			},
		];
	}, []);

	const priceValue = genPriceValue();

	// console.log('check config cart item v2', variants);

	// console.log('check config variant current', variant);

	return (
		<div className='flex gap-[30px] first-of-type:pt-0 last-of-type:border-b-0 py-[30px] border-b border-gray-custom'>
			<div className='flex flex-col gap-3'>
				<div className='w-[130px] h-full aspect-square overflow-hidden'>
					<ImageCustom fill src={image ?? ''} objectFit='contain' className='!h-full' />
				</div>
				<div
					className={classNames([
						'uppercase cursor-pointer underline text-[#71717A] text-base font-bold text-center',
						// dataCart?.isRequestAdd && '!cursor-not-allowed',
					])}
					onClick={() => onRemoveItem(id)}
				>
					xóa
				</div>
			</div>
			<div className='flex flex-col my-[calc(90px_-_65px)] flex-auto gap-3 justify-start'>
				<div
					className='tooltip w-full group-hover:tooltip-open whitespace-normal break-words before:bg-black/25 after:border-[black_transparent_transparent_transparent]'
					data-tip={name}
				>
					<span
						onClick={() => router.push(`/chi-tiet/${id}`)}
						className='line-clamp-1 text-left font-bold mb-[6px] cursor-pointer'
					>
						{name}
					</span>
				</div>
				<div className='flex items-center gap-3'>
					<div className='flex flex-col gap-1'>
						{/* {attributeConfig.length > 0 &&
							attributeConfig.map((item, index) => {
								return (
									<div key={index}>
										<div className='flex gap-14 mt-5 items-center'>
											<div className='text-base whitespace-nowrap'>{item.key}:</div>
											<div className='flex flex-wrap items-center gap-2.5'>
												{item.value?.map((attr, i) => (
													<button
														type='button'
														className={classNames([
															'bg-[#ECEAEA] min-h-[0px] h-[32px] font-normal !text-left capitalize w-fit btn border-none hover:bg-primary hover:text-base-100 rounded-[16px] px-[12px] py-[6px] text-small text-primary',
															variant && variant === attr.variantId && '!bg-primary !text-base-100',
														])}
														key={i}
														onClick={() => {
															handleSelectVariant(attr.variantId);
														}}
													>
														{attr.value}
													</button>
												))}
											</div>
										</div>
									</div>
								);
							})} */}
						{/* <p className='text-[#71717A]'>{'fads'}</p> */}

						{attributeConfig.length > 0 && (
							<ModalSelectVariantV2
								variant={variant}
								open={variantDialog}
								config={attributeConfig}
								onToggleDialog={handleDialog}
								onSelectVariant={handleSelectVariant}
							/>
						)}

						<p className='text-[#71717A]'>
							{variants.attributes.map((item) => item.value).join(' - ')}
						</p>
					</div>
					<div className='gap-6 flex-auto flex flex-row items-center'>
						<div className='font-normal text-medium text-primary'>
							{priceValue.price?.toLocaleString('it-IT')}₫
						</div>
						<div className='flex gap-3 flex-auto'>
							<div className='inline-flex flex-shrink w-auto overflow-hidden text-primary mt-2 rounded-[5px] h-[32px] lg:!h-[40px] lg:mt-0 border border-secondary items-center'>
								<div className={classNames([numb <= 1 && 'cursor-not-allowed'])}>
									<button
										className={classNames([
											'lg:p-4 aspect-square btn btn-ghost h-[32px] lg:!h-fit rounded-none',
											numb <= 1 && 'pointer-events-none',
										])}
										onClick={() => {
											// setNumb(numb - 1);
											handleChangeQuantity(numb - 1);
										}}
									>
										-
									</button>
								</div>
								<input
									className='outline-none text-center h-[32px] w-[54px] bg-inherit justify-center items-center aspect-square'
									value={numb}
									type='text'
									onChange={(e) => {
										const quantityChange = +e.target.value;
										// setQuantity(quantityChange);
										// onChange?.(quantityChange);
									}}
									onBlur={(e) => {
										const quantityChange = +e.target.value;
										// !quantityChange && setQuantity(1);
										// !quantityChange && onChange?.(1);
									}}
								/>

								<div>
									<button
										className={classNames([
											'lg:p-4 aspect-square btn btn-ghost h-[32px] lg:!h-fit rounded-none',
										])}
										onClick={() => {
											handleChangeQuantity(numb + 1);
											// setQuantity(countQuantity + 1);
											// onChange?.(countQuantity + 1);
										}}
									>
										+
									</button>
								</div>
							</div>
							<div className='flex-auto flex items-center justify-end'>
								<span className='text-medium font-bold'>
									{priceValue.price && (priceValue.price * numb)?.toLocaleString('it-IT')}₫
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CartItemV2;
